export default function UlPoint() {
	return (
		<div className={"linkUlPoint"}>
			<div className={"ulPointBottom"} />
			<div className={"ulPointRight"} />
			<div className={"ulPointDiag"} />
		</div>
	);
}
